import * as React from "react";
import { SVGProps } from "react";

const BANCO_SUPERVIELLE_LOGO_PATHS = (
  <g>
    <path
      fill="#fff"
      d="M23.42,37.35c-1.05-.36-1.35-.53-1.35-.97,0-.4.44-.71,1.03-.71.55,0,1.12.16,1.75.48,0,0,.02,0,.04,0,.01,0,.02,0,.03,0,.02-.01.04-.04.04-.06l.17-1.1s-.01-.06-.04-.08c-.57-.26-1.27-.4-1.96-.4-1.35,0-2.3.81-2.3,1.98,0,1.08.72,1.53,2.15,2.02.93.33,1.25.52,1.25,1.01s-.47.82-1.22.82c-.62,0-1.45-.22-2.13-.57,0,0-.02-.01-.03-.01-.02,0-.03,0-.04.01-.02.01-.03.04-.04.06l-.17,1.06s.01.07.04.08c.77.33,1.59.51,2.31.51,1.51,0,2.51-.83,2.51-2.09,0-1.13-.72-1.6-2.05-2.06h0ZM32.27,34.62h-1.18s-.08.03-.08.08v4.03c0,1.08-.51,1.64-1.48,1.64s-1.45-.59-1.45-1.68v-4s-.03-.08-.08-.08h-1.17s-.08.03-.08.08v4.05c0,1.75,1.04,2.79,2.77,2.79s2.82-1.07,2.82-2.85v-4s-.04-.08-.08-.08h0Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      opacity={0.61}
      d="M83.26,24.85c-3.45.66-8.45,2.26-13.26,5.58-.2.15-.29-.03-.18-.15,2.25-2.15,4.41-5.28,5.52-8.2,1.92.91,4.89,1.9,7.91,2.39.2.04.19.33.01.37h0Z"
    />
    <path
      fill="#fff"
      d="M66.76,16.73c1.14,2.94,2.44,8.93-.62,15.49-.03.09.08.16.19.08,3.66-2.4,6.85-6.99,7.9-10.75-3.63-1.85-5.83-3.79-7.16-5.03-.18-.17-.4.02-.32.21h0Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M38.84,36.73c0,1.36-.95,2.14-2.59,2.14h-.76v2.47s-.03.08-.08.08h-1.17s-.08-.03-.08-.08v-6.63s.04-.08.08-.08h2.15c1.51,0,2.45.8,2.45,2.11h0ZM37.53,36.75c0-.81-.67-.98-1.25-.98h-.79v1.97h.76c.86,0,1.27-.32,1.27-.99ZM44.52,40.3v1.03s-.03.08-.08.08h-4.21s-.08-.03-.08-.08v-6.63s.04-.08.08-.08h4.12s.08.03.08.08v1.03s-.04.09-.08.09h-2.87v1.48h2.28s.07.02.08.07l.17,1.03s-.01.04-.02.06c-.01.02-.03.03-.06.03h-2.45v1.73h2.96s.08.04.08.08ZM51.07,41.09s.02.05.01.07c-.01.02-.02.04-.06.04l-1.22.28h-.02s-.04-.01-.06-.03l-1.83-2.61h-.6v2.49s-.03.08-.08.08h-1.18s-.08-.03-.08-.08v-6.63s.03-.08.08-.08h2.06c1.61,0,2.58.79,2.58,2.11,0,.91-.48,1.59-1.34,1.93l1.73,2.43ZM48.07,35.8h-.79v1.97h.79c.81,0,1.25-.36,1.25-1.01,0-.8-.68-.95-1.25-.95h0ZM57.87,34.65s.02.06,0,.08l-2.62,6.62s-.04.06-.08.06h-1.09s-.06-.02-.06-.06l-2.59-6.63s0-.04.01-.06c0-.02.02-.04.04-.04h1.29s.07.02.08.06l1.82,4.97,1.87-4.97s.04-.04.07-.04h1.19s.04.01.07.02h0ZM59.11,34.7s.04-.08.08-.08h1.18s.08.04.08.08v6.63s-.04.08-.08.08h-1.18s-.08-.04-.08-.08v-6.63ZM66.99,40.3v1.02s-.04.08-.08.08h-4.22s-.08-.04-.08-.08v-6.63s.04-.08.08-.08h4.12s.08.03.08.08v1.04s-.03.08-.08.08h-2.86v1.48h2.28s.08.03.08.07l.17,1.03s0,.04,0,.06c-.02.02-.05.03-.07.03h-2.44v1.75h2.96s.08.03.08.08h0ZM77.76,40.3l.17,1.01s0,.05-.02.07c-.02.02-.04.02-.06.02h-3.86s-.08-.04-.08-.08v-6.63s.03-.08.08-.08h1.18s.08.03.08.08v5.54h2.43s.07.02.08.07ZM83.39,40.3v1.02s-.03.08-.08.08h-4.21s-.08-.04-.08-.08v-6.63s.04-.08.08-.08h4.12s.08.03.08.08v1.04s-.03.08-.08.08h-2.86v1.48h2.28s.06.03.08.07l.17,1.03s0,.04-.02.06c-.01.02-.03.03-.06.03h-2.44v1.75h2.95s.08.03.08.08h0ZM72.58,40.3l.17,1.01s0,.05-.01.07c-.02.02-.04.02-.07.02h-3.86s-.08-.04-.08-.08v-6.63s.04-.08.08-.08h1.18s.08.03.08.08v5.54h2.43s.08.02.08.07h0Z"
    />
  </g>
);

const BancoSupervielleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={32} height={20} rx={6} fill="#ed1c24" />
    <g transform="translate(-8.48, -5.12) scale(0.48)">{BANCO_SUPERVIELLE_LOGO_PATHS}</g>
  </svg>
);

export default BancoSupervielleIcon;
